import { render, staticRenderFns } from "./supplierMetricRequests.vue?vue&type=template&id=d6feb70e&scoped=true"
import script from "./supplierMetricRequests.vue?vue&type=script&lang=js"
export * from "./supplierMetricRequests.vue?vue&type=script&lang=js"
import style0 from "./supplierMetricRequests.vue?vue&type=style&index=0&id=d6feb70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6feb70e",
  null
  
)

export default component.exports